import { useContext, useEffect, useState } from "react"
import { MainContext } from "../../controllers/main"
import ChallengeMobile from "../../components/challenge/ChallengeMobile"
import ChallengeDesktop from "../../components/challenge/ChallengeDesktop"
import {
  registerPageEvent,
  scrollWindowToTop,
} from "../../services/utils/utils"
import ChallengeModel from "../../models/challenge"
import { ChallengeContext } from "../../controllers/challenge"
import { UsersContext } from "../../controllers/users"
import { MissionsContext } from "../../controllers/missions"

const Challenge = () => {
  const { isMobile, isOldChallenge } = useContext(MainContext)
  const { oldChallenge, challenge, oldChallengeSavings, challengeSavings } =
    useContext(ChallengeContext)
  const { getLeaderboard } = useContext(UsersContext)
  const { getMissionsHistory, getPerformanceCount } =
    useContext(MissionsContext)

  // register google analytics event
  useEffect(() => {
    registerPageEvent("challenge")
  }, [])

  // manage old challenge
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true)
  const [displayedChallenge, setDisplayedChallenge] = useState<ChallengeModel>(
    challenge!
  )
  const [displayedSavings, setDisplayedSavings] = useState<{
    co2Saving: number
    waterSaving: number
    energySaving: number
  } | null>(challengeSavings)
  const [displayedLeaderboardLoading, setDisplayedLeaderboardLoading] =
    useState<boolean>(false)

  useEffect(() => {
    const changeData = async () => {
      setTimeout(() => {
        scrollWindowToTop("smooth")
      }, 10)

      setDisplayedChallenge(isOldChallenge ? oldChallenge! : challenge!)
      setDisplayedSavings(
        isOldChallenge ? oldChallengeSavings : challengeSavings
      )

      setDisplayedLeaderboardLoading(true)
      await Promise.all([
        getLeaderboard(false, false),
        getMissionsHistory(false, false),
        getPerformanceCount(false),
      ])
      setDisplayedLeaderboardLoading(false)
    }

    if (!isFirstRender) {
      changeData()
    } else {
      setIsFirstRender(false)
    }
  }, [isOldChallenge])

  return isMobile ? (
    <ChallengeMobile
      displayedChallenge={displayedChallenge}
      displayedSavings={displayedSavings}
      displayedLeaderboardLoading={displayedLeaderboardLoading}
    />
  ) : (
    <ChallengeDesktop
      displayedChallenge={displayedChallenge}
      displayedSavings={displayedSavings}
      displayedLeaderboardLoading={displayedLeaderboardLoading}
    />
  )
}

export default Challenge
